export default {
  clientID(state) {
    return state.clientID || sessionStorage.getItem('clientID');
  },
  clientFullName(state) {
    return `${state.firstName || sessionStorage.getItem('clientFirstName')} ${
      state.lastName || sessionStorage.getItem('clientLastName')
    }`;
  },
  balance(state) {
    return state.balance || sessionStorage.getItem('balance');
  },
  email(state) {
    return state.email || sessionStorage.getItem('email');
  },
  isOverseas(state) {
    if (state.isOverseas != null) {
      return state.isOverseas;
    } else {
      let isOverseasFromStorage = sessionStorage.getItem('isOverseas');
      if (isOverseasFromStorage == 'true' || isOverseasFromStorage == true)
        return true;
      else return false;
    }
  },
  clientCode(state) {
    return state.clientCode || sessionStorage.getItem('clientCode');
  },
  phone(state) {
    return state.phone || sessionStorage.getItem('phone');
  },

  walletID(state) {
    return state.walletID || sessionStorage.getItem('clientWalletID');
  },
  clientList(state) {
    if (!state.clientList || state.clientList.length == 0) {
      return JSON.parse(sessionStorage.getItem('clientList'));
    }
    return state.clientList;
  },

  workshopSearchModel(state) {
    // debugger;
    // if (!state.workshopSearchModel) {
    //   return JSON.parse(sessionStorage.getItem('workshopSearchModel'));
    // }
    return state.workshopSearchModel;
  },
  currentPanel(state) {
    // debugger;
    // if (!state.workshopSearchModel) {
    //   return JSON.parse(sessionStorage.getItem('workshopSearchModel'));
    // }
    return state.currentPanel;
  },
};
